/**
 * @animus/palette
 *
 * Platform-agnostic color definitions for the Animus design system.
 * These colors can be used across web, mobile, and any other platform.
 */

export const palette = {
  // Primary brand colors (Strawberry Glaze Pink)
  primary: {
    50: "#FFF5F6",
    100: "#FFE8EB",
    200: "#FFCCD4",
    300: "#FFAAB8",
    400: "#E88899",
    500: "#CC7080",
    600: "#B05868",
    700: "#944858",
    800: "#7A3A48",
    900: "#602E3A",
    950: "#3D1D24",
  },

  // Neutral grays (cooler undertone)
  neutral: {
    0: "#ffffff",
    50: "#fafbfc",
    100: "#f4f5f7",
    200: "#e8eaed",
    300: "#d1d5db",
    400: "#9ca3af",
    500: "#6b7280",
    600: "#4b5563",
    700: "#374151",
    800: "#1f2937",
    900: "#111827",
    950: "#0a0e14",
  },

  // Semantic colors
  success: {
    light: "#86efac",
    DEFAULT: "#10b981",
    dark: "#047857",
  },

  warning: {
    light: "#fcd34d",
    DEFAULT: "#f59e0b",
    dark: "#b45309",
  },

  error: {
    light: "#fca5a5",
    DEFAULT: "#ef4444",
    dark: "#b91c1c",
  },

  info: {
    light: "#FFAAB8",
    DEFAULT: "#E88899",
    dark: "#B05868",
  },

  // Animus brand colors
  brand: {
    // Strawberry Glaze (Primary Pink)
    pink: {
      50: "#FFF5F6",
      100: "#FFE8EB",
      200: "#FFCCD4",
      300: "#FFAAB8",
      400: "#E88899",
      500: "#CC7080",
      600: "#B05868",
    },
    // Vanilla Cream (Background/Base)
    cream: {
      50: "#FFFDFB",
      100: "#FFF9F4",
      200: "#FFF3E8",
      300: "#FFE8D4",
    },
    // Champagne Gold (Accent)
    gold: {
      400: "#D4A855",
      500: "#B8923D",
    },
    // Dark mode (Warm Espresso)
    dark: {
      bg: "#1A1614",
      card: "#2A2422",
      border: "#3A3230",
    },
  },
} as const;

export type Palette = typeof palette;

// Individual color exports for convenience
export const { primary, neutral, success, warning, error, info, brand } =
  palette;
